import { render, staticRenderFns } from "./weeklyPlacingsTable.vue?vue&type=template&id=15dad992&scoped=true&"
import script from "./weeklyPlacingsTable.vue?vue&type=script&lang=js&"
export * from "./weeklyPlacingsTable.vue?vue&type=script&lang=js&"
import style0 from "./weeklyPlacingsTable.vue?vue&type=style&index=0&id=15dad992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dad992",
  null
  
)

export default component.exports